import { ApolloProvider } from '@apollo/client/react';
import { apolloClient } from '../core/api/client.js';
import { AppRouter } from './Router.jsx';
import { ErrorBoundary } from './ErrorBoundary.jsx';
import { ToastContainer } from '../components/ui/Toast.jsx';
import { OfflineBanner, ImpersonationBanner } from '../components/layout/Banners.jsx';

export function AppProviders() {
  return (
    <ErrorBoundary>
      <ApolloProvider client={apolloClient}>
        <OfflineBanner />
        <ImpersonationBanner />
        <AppRouter />
        <ToastContainer />
      </ApolloProvider>
    </ErrorBoundary>
  );
}
